import { getSKUFilters } from './LocateVendingMachines.repo'

const defaultState = {
  isFetchingFilters: false,
  showFetchingFiltersErrorPopup: false,
  skuFilters: [{
    skuId: 'all',
    displayName: 'All'
  }]
}

const getters = {
  skuFilters: (state) => state.skuFilters,
  isFetchingFilters: (state) => state.isFetchingFilters,
  showFetchingFiltersErrorPopup: (state) => state.showFetchingFiltersErrorPopup
}

const mutations = {
  setSkuFilters: (state, skuFilters) => {
    const allFilter = {
      displayName: 'All',
      skuId: 'all'
    }
    const updatedSkuFilters = [allFilter, ...skuFilters]
    state.skuFilters = updatedSkuFilters
  },
  setIsFetchingFilters: (state, isFetchingFilters) => {
    state.isFetchingFilters = isFetchingFilters
  },
  setShowFetchingFiltersErrorPopup: (state, showFetchingFiltersErrorPopup) => {
    state.showFetchingFiltersErrorPopup = showFetchingFiltersErrorPopup
  }
}

const actions = {
  getSkuFilters: async ({ commit }) => {
    try {
      commit('setIsFetchingFilters', true)
      const filters = await getSKUFilters()
      commit('setSkuFilters', filters)
      commit('setShowFetchingFiltersErrorPopup', false)
    } catch (error) {
      commit('setShowFetchingFiltersErrorPopup', true)
    } finally {
      commit('setIsFetchingFilters', false)
    }
  }
}

export default {
  state: defaultState,
  getters,
  mutations,
  actions
}
